import { render, staticRenderFns } from "./statoServizi.vue?vue&type=template&id=864456a4&"
import script from "./statoServizi.vue?vue&type=script&lang=js&"
export * from "./statoServizi.vue?vue&type=script&lang=js&"
import style0 from "./statoServizi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports